// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"ChangeUserTypeModal_modalContainer__2zY09","modalContent":"ChangeUserTypeModal_modalContent__3ibKg"};